import UserLogin from '@/views/User/Login.vue'
import PasswordReset from '@/views/User/PasswordReset.vue'

export default [
    {
        path: '/login',
        name: 'userLogin',
        component: UserLogin,
        meta: {
            title: 'common.auth.loginTitle',
            menuRendered: false,
            requiresVisitor: true
        }
    },
    {
        path: '/password-reset',
        name: 'password-reset',
        component: PasswordReset,
        meta: {
            title: 'common.auth.passwordResetTitle',
            menuRendered: false,
            requiresVisitor: true
        }
    }
]
